import { Grid, Header } from 'semantic-ui-react'
import CloudinaryPicSet from '../components/CloudinaryPicSet'
import React from 'react'

export default function HelloSection() {
	return (
		<Grid verticalAlign="middle" stackable>
			<Grid.Column width="2" textAlign="center">
				<CloudinaryPicSet
					className="ui small circular image anthony-main-picture"
					alt="Anthony Astige"
					filename="anthony.astige.com/misc/anthony"
					defaultWidth={200}
					widths={[522, 400, 300, 200, 100]}
					ext="jpg"
				/>
			</Grid.Column>
			<Grid.Column width="14">
				<Header as="h2">I&#39;m Anthony, a San Francisco Bay Area web developer</Header>
			</Grid.Column>
		</Grid>
	)
}



// WEBPACK FOOTER //
// ./src/sections/HelloSection.js